import { useContext } from "react";
import { useRouter } from "next/router";
import { getAuthenticatedUserClient } from "../utils/getAuthenticatedUser";
import { CookieContext } from "../context/cookieContext";

const CreateAccount = () => {
    const router = useRouter();
    const token = useContext(CookieContext);
    getAuthenticatedUserClient(token, router);

    return null;
};

export default CreateAccount;
